<!--
	Fixed footer bar showing Terms of use, map coordinates (on mousemove), and copyright.
-->
<script lang="ts">
	import { coordinatesStore } from '#lib/stores/coordinatesStore.svelte.js';
	import { copyrightStartYear } from '#lib/config.js';

	const currentYear = new Date().getFullYear();
	const yearText =
		copyrightStartYear && copyrightStartYear < currentYear
			? `${copyrightStartYear}-${currentYear}`
			: `${currentYear}`;
</script>

<footer class="footer">
	<div>
		View the <a href="https://abley.com/en-us/terms-of-use" target="_blank"
			>Terms of use<span class="screenReaderOnly"> (opens in new tab)</span></a>
	</div>

	{#if coordinatesStore.showCoordinates && coordinatesStore.coordinates.length > 0}
		<div class="coordinatesDisplay">
			{#if coordinatesStore.justCopied}
				<div>Coordinates copied to clipboard</div>
			{:else}
				<div>
					<span class="coordinatesLabel">Coordinates (right-click to copy):</span>
					<span class="coordinatesValue">{coordinatesStore.coordinates}</span>
				</div>
			{/if}
		</div>
	{/if}

	<div>
		© {yearText} Developed by
		<a href="https://abley.com/" target="_blank"
			>Abley Ltd.<span class="screenReaderOnly"> (opens in new tab)</span></a>
	</div>
</footer>

<style>
	/* main (flex: 1 1 0) shrinks to leave room for the footer's natural height. */
	.footer {
		display: flex;
		justify-content: space-between;
		align-items: center;
		background-color: var(--surface-inverse);
		padding: var(--space-1) var(--space-6);
		color: var(--text-inverse);
		font-size: var(--font-size-xs);

		a {
			color: inherit;
		}
	}

	.coordinatesDisplay {
		display: none;

		@media screen and (min-width: 700px) {
			display: block;
		}
	}

	.coordinatesLabel {
		user-select: none;
	}

	.coordinatesValue {
		user-select: text;
	}
</style>
